// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
// import Button from 'sushiweb/Button';
import {
  // ChevronLeft,
  ChevronRight,
  // Upload
} from 'sushiweb/Icons';
import {
  FooterWrapper,
  Footer,
  RightButton,
  // ButtonWrapper,
  // StyledButton,
} from '../styles';

const FooterBar = ({
  currentForm,
  isVerifying,
  formChecked,
  // goBack,
  goNext,
  // disabled,
  // uploadEmployeeData,
  // loading,
  // uploadStatus,
}) => {
  return (
    <FooterWrapper>
      <Footer>
        {/* {currentForm !== 'step-1' && (
          <Button
            appearance='outline'
            icon={<ChevronLeft />}
            iconAlign='left'
            btnColor='red'
            onClick={goBack}
            disabled={
              loading ||
              ['failed', 'completed', 'terminated'].includes(uploadStatus)
            }
          >
            Go Back
          </Button>
        )} */}
        {/* {currentForm === 'step-2' && (
          <ButtonWrapper>
            {uploadStatus === '' && (
              <StyledButton
                loading={loading}
                disabled={!disabled}
                iconAlign='right'
                icon={<Upload />}
                btnColor='red'
                onClick={uploadEmployeeData}
              >
                Upload
              </StyledButton>
            )} */}
        {/* <StyledButton
              loading={isVerifying}
              disabled={loading}
              iconAlign='right'
              icon={<ChevronRight />}
              btnColor='red'
              onClick={goNext}
            >
              {uploadStatus === '' ? 'Skip' : 'Finish'}
            </StyledButton>
          </ButtonWrapper>
        )} */}
        {/* {currentForm !== 'step-2' && ( */}
        <RightButton
          loading={isVerifying}
          disabled={!formChecked && currentForm !== 'step-2'}
          iconAlign='right'
          icon={<ChevronRight />}
          btnColor='red'
          onClick={goNext}
        >
          Next
        </RightButton>
        {/* )} */}
      </Footer>
    </FooterWrapper>
  );
};

FooterBar.propTypes = {
  currentForm: PropTypes.string,
  formChecked: PropTypes.bool,
  isVerifying: PropTypes.bool,
  // goBack: PropTypes.func,
  goNext: PropTypes.func,
  // disabled: PropTypes.bool,
  // uploadEmployeeData: PropTypes.func,
  // loading: PropTypes.bool,
  // uploadStatus: PropTypes.string,
};

FooterBar.defaultProps = {
  currentForm: '',
  formChecked: false,
  isVerifying: false,
  // disabled: true,
  // loading: false,
  // uploadStatus: '',
  // goBack: _noop,
  goNext: _noop,
  // uploadEmployeeData: _noop,
};

export default FooterBar;
